import { type ComponentType } from 'react';
import { Image } from '@direct-frontend/components';
import { type ErrorBlankProps } from '../types';

/**
 * Данные для hoc withImage
 */
interface ImageProps {
    /**
     * Ссылка на картинку
     */
    imageSrc: string;
    /**
     * alt картинки
     */
    imageAlt: string;
}

/**
 * Входные данные для компонента после hoc withImage
 */
export type ErrorBlankWithImageProps = Omit<ErrorBlankProps, 'Header'> & Partial<ImageProps>;

/**
 * HOC для изначального прокидывания настроек картинок в компонент ErrorBlank
 * @param Component - компонент ErrorBlank
 * @param props - данные для прокидывания
 * @kind helper
 * @returns Новый компонент ErrorBlank с imageSrc и imageAlt по-умолчанию заданными
 */
export function withImage(
    Component: ComponentType<ErrorBlankProps>,
    props: ImageProps
): ComponentType<ErrorBlankWithImageProps> {
    const { imageSrc, imageAlt } = props;

    return function WithImageComponent({
        imageSrc: newImageSrc,
        imageAlt: newImageAlt,
        ...newProps
    }: ErrorBlankWithImageProps) {
        return (
            <Component
                header={
                    <Image height="120px" width="120px" src={newImageSrc ?? imageSrc} alt={newImageAlt ?? imageAlt} />
                }
                {...newProps}
            />
        );
    };
}
